export class Playlist {
    public readonly name: string;
    public value?: any;
    public callbacks: Function[];

    constructor(name: string) {
        this.name = name;
        this.callbacks = [];
    }

    public getName(): string {
        return this.name;
    }

    public setValue(value: any) {
        this.value = value;
    }

    public getValue(): any | undefined {
        return this.value;
    }

    public getCallbacks(): Function[] {
        return this.callbacks;
    }

    // Stays registered after the first value, so a reload or resync reaches every subscriber.
    public addCallback(callback: Function) {
        if (!this.callbacks.includes(callback)) this.callbacks.push(callback);
        if (this.value != undefined) callback(this);
    }

    public removeCallback(callback: Function): void {
        const idx = this.callbacks.indexOf(callback);
        if (idx !== -1) this.callbacks.splice(idx, 1);
    }
}